import features from './features';
import { type State } from '../State';

export type OpenWebBehavior = 'default_web' | 'native_only';

/**
 * Returns the open web behavior based on the user's features.
 *
 * @param state
 */
export function getOpenWebBehavior(state: State): OpenWebBehavior {
  const { openWebPayments } = features(state);
  return openWebPayments ? 'default_web' : 'native_only';
}
